<div class="page-content">
  <!-- Header Section -->
  <div class="page-title-container">
    <div class="breadcrumb-spacer"></div>
    <h1 class="page-title">Role Management</h1>
  </div>

  <div class="roles-container">
    <!-- Filters Section -->
    <mat-card class="filters-card">
      <mat-card-content>
        <form [formGroup]="searchForm" class="filters-form">
          <div class="filter-row">
            <!-- Search Field -->
            <mat-form-field appearance="outline" class="search-field">
              <mat-label>Search roles</mat-label>
              <input
                matInput
                [(ngModel)]="searchQuery"
                [ngModelOptions]="{ standalone: true }"
                placeholder="Search by name or description..."
                autocomplete="off"
                (input)="onSearchInput()"
              />
              <mat-icon
                matSuffix
                [style.cursor]="searchQuery ? 'pointer' : 'default'"
                (click)="clearSearch()"
                >{{ searchQuery ? "close" : "search" }}</mat-icon
              >
            </mat-form-field>
            <button
              mat-stroked-button
              class="reset-filters-btn"
              type="button"
              (click)="clearSearch()"
              [disabled]="!searchQuery"
            >
              <mat-icon>replay</mat-icon>
              Reset
            </button>
          </div>
        </form>
      </mat-card-content>
    </mat-card>

    <!-- Loading State -->
    @if (isLoading) {
      <div class="loading-container">
        <mat-spinner diameter="40"></mat-spinner>
        <span>Loading roles...</span>
      </div>
    }

    <!-- Error State -->
    @if (error && !isLoading) {
      <app-error-state
        [message]="error"
        (retry)="loadRoles()"
      ></app-error-state>
    }

    <!-- Table Section -->
    @if (!isLoading && !error) {
      <mat-card class="table-card no-padding">
        <mat-card-content>
          <div class="table-container">
            <table mat-table [dataSource]="dataSource" class="roles-table">
              <!-- Name Column -->
              <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef>Name</th>
                <td mat-cell *matCellDef="let role">
                  <div class="role-name">
                    <span>{{ role.name }}</span>
                    @if (role.isProtectedAdmin) {
                      <mat-icon
                        class="protected-icon"
                        matTooltip="Protected system role"
                      >
                        lock
                      </mat-icon>
                    }
                  </div>
                </td>
              </ng-container>

              <!-- Description Column -->
              <ng-container matColumnDef="description">
                <th mat-header-cell *matHeaderCellDef>Description</th>
                <td mat-cell *matCellDef="let role">
                  <span class="role-description">{{
                    role.description || "No description"
                  }}</span>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr
                mat-row
                *matRowDef="let row; columns: displayedColumns"
                (click)="onRowClick(row)"
                class="clickable-row"
              ></tr>

              <!-- Empty State -->
              <tr class="mat-row" *matNoDataRow>
                <td
                  class="mat-cell no-data-cell"
                  [attr.colspan]="displayedColumns.length"
                >
                  <div class="empty-state">
                    <mat-icon>search_off</mat-icon>
                    <span>No roles found matching your search</span>
                  </div>
                </td>
              </tr>
            </table>
          </div>

          <mat-paginator
            [length]="totalCount"
            [pageSize]="pageSize"
            [pageIndex]="pageIndex"
            [pageSizeOptions]="pageSizeOptions"
            (page)="onPageChange($event)"
            showFirstLastButtons
          >
          </mat-paginator>
        </mat-card-content>
      </mat-card>
    }
  </div>
</div>
